<div class="bar">
  @if (pointType(); as pointType) {
    <div
      class="point {{ pointType.color }}"
      tabindex="-1"
      [onyxTooltip]="`labels.${expanded() ? 'collapse' : 'expand'}`"
      (click)="toggleExpanded()"
      (keydown)="(null)"
    >
      <onyx-icon
        class="point-icon"
        [name]="pointType.icon"
        [size]="16"
      ></onyx-icon>

      <onyx-icon
        class="expand-icon"
        [name]="
          expanded() ? 'arrow-alt-up-outlined' : 'arrow-alt-down-outlined'
        "
        [size]="20"
      ></onyx-icon>
    </div>
  }
</div>

<div class="container" [class.collapsed]="!expanded()">
  <div class="heading">
    <h6 [class.invalid]="invalidTimeWindow()">
      {{ pointType()?.name }} {{ point().typeIndex + 1 }}
    </h6>

    @if (!isHandlingPoint()) {
      <div class="separator"></div>

      <div class="include-in-order">
        <onyx-toggle
          [formControl]="$any(point().form.controls).includeInOrder"
          label="labels.includeInOrder"
          [size]="32"
        ></onyx-toggle>

        <onyx-tooltip
          [tooltip]="`${I18N}.includeInOrderHint` | translate"
          [size]="16"
        ></onyx-tooltip>
      </div>
    }

    @if (hasSemiTrailerPickup()) {
      <div class="separator"></div>

      <onyx-badge color="light-green">
        {{ `${I18N}.semiTrailerPickupPoint` | translate }}
      </onyx-badge>
    } @else if (hasSemiTrailerDrop()) {
      <div class="separator"></div>

      <onyx-badge color="light-red-alt">
        {{ `${I18N}.semiTrailerDropPoint` | translate }}
      </onyx-badge>
    }

    @let hasOptions = !!dropdownOptions().length;
    @let hasMove = hasMoveUp() || hasMoveDown();
    @if (hasOptions || hasMove || hasRemove()) {
      <div class="options">
        @if (hasOptions) {
          <onyx-icon-button
            variant="transparent"
            color="gray"
            [size]="32"
            icon="options-horizontal-filled"
            [onyxDropdownOptions]="dropdownOptions()"
            (onyxDropdownSelectedValueChange)="$event.value?.()"
            (click)="$event.stopPropagation()"
          ></onyx-icon-button>
        }

        @if (hasMove) {
          <onyx-icon-button
            variant="transparent"
            color="gray"
            [size]="32"
            icon="arrow-up-outlined"
            [disabled]="!hasMoveUp()"
            onyxTooltip="labels.moveUp"
            (click)="hasMoveUp() ? movePoint.emit(-1) : null"
          ></onyx-icon-button>

          <onyx-icon-button
            variant="transparent"
            color="gray"
            [size]="32"
            icon="arrow-down-outlined"
            [disabled]="!hasMoveDown()"
            onyxTooltip="labels.moveDown"
            (click)="hasMoveDown() ? movePoint.emit(1) : null"
          ></onyx-icon-button>

          <div class="separator"></div>
        }

        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="delete-outlined"
          [disabled]="!hasRemove()"
          onyxTooltip="labels.delete"
          (click)="hasRemove() ? removePoint.emit() : null"
        ></onyx-icon-button>
      </div>
    }
  </div>

  <div class="content">
    @switch (point().category) {
      @case (OrderPointCategory.LOADING) {
        <app-order-loading-point-form
          [form]="$any(point().form)"
          [goods]="point().goods"
          [disabled]="disabled()"
          [parametersValidation]="parametersValidation()"
          [isCompleted]="isCompleted()"
        ></app-order-loading-point-form>
      }
      @case (OrderPointCategory.UNLOADING) {
        <app-order-unloading-point-form
          [form]="$any(point().form)"
          [goods]="point().goods"
          [disabled]="disabled()"
          [isCompleted]="isCompleted()"
        ></app-order-unloading-point-form>
      }
      @case (OrderPointCategory.CHECKPOINT) {
        <app-order-checkpoint-form
          [form]="$any(point().form)"
          [disabled]="disabled()"
        ></app-order-checkpoint-form>
      }
      @case (OrderPointCategory.PICKUP) {
        <app-order-checkpoint-form
          [form]="$any(point().form)"
          [disabled]="disabled()"
        ></app-order-checkpoint-form>
      }
      @case (OrderPointCategory.TRANSIT) {
        <app-order-transit-form
          [form]="$any(point().form)"
          [disabled]="disabled()"
        ></app-order-transit-form>
      }
    }
  </div>
</div>
